import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { Parallax } from "react-parallax";
//import MainHorses from "../../pages/MainHorsesBW.jpeg";
import MainHorsesDesktop from "./HorizontalPalm.JPG"
import MainHorsesMobile from "./VerticalTent.JPG"
//import MainHorses from "./HorizontalTent.png"

import "./pages.css";
import { ParallaxBanner } from "react-scroll-parallax";
import chukkerbookTheme from "../../chukkerbbokTheme";
function BackgroundParallax() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const MainHorses = isDesktop ? MainHorsesDesktop : MainHorsesMobile;
  const advancedLib = true;
  if (!advancedLib) {
    return (
      <Parallax className="image" bgImage={MainHorses} strength={700}>
        <Typography
          className="content"
          variant="h2"
          color={chukkerbookTheme["warning"]}
          style={{ textShadow: "0 0 30px black" }}
        >
          Less time planning
        </Typography>
        <Typography
          className="content"
          variant="h2"
          color={chukkerbookTheme["warning"]}
          style={{ textShadow: "0 0 30px black" }}
        >
          <strong>More time playing</strong>
        </Typography>
        <Typography
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            fontSize: isDesktop ? "0.7rem" : "0.55rem",
            color: "white",
            textShadow: "0 0 10px rgba(0,0,0,0.8)",
            opacity: 0.9
          }}
        >
          © K. Kerley Photography
        </Typography>
      </Parallax>
    );
  } else {
    return (
      <ParallaxBanner
        layers={[{ image: MainHorses, speed: -20 }]}
        className="image"
      >
        <div 
          className="content" 
          style={{ 
            flexDirection: "column", 
            gap: "1rem",
            padding: isDesktop ? "0" : "1rem 1.5rem",
            backgroundColor: isDesktop ? "transparent" : "rgba(0,0,0,0.3)",
            borderRadius: isDesktop ? "0" : "8px"
          }}
        >
          <Typography
            variant={isDesktop ? "h2" : "h3"}
            color={chukkerbookTheme["warning"]}
            style={{ 
              textShadow: isDesktop ? "0 0 30px black" : "0 0 20px rgba(0,0,0,0.8), 0 0 40px rgba(0,0,0,0.6)", 
              fontWeight: isDesktop ? 600 : 500, 
              fontStyle: "italic", 
              textAlign: "center"
            }}
          >
            Less time planning
          </Typography>
          <Typography
            variant={isDesktop ? "h1" : "h2"}
            color={chukkerbookTheme["warning"]}
            style={{ 
              textShadow: isDesktop ? "0 0 30px black" : "0 0 20px rgba(0,0,0,0.8), 0 0 40px rgba(0,0,0,0.6)", 
              fontWeight: isDesktop ? 600 : 500, 
              fontStyle: "italic", 
              textAlign: "center"
            }}
          >
            <strong>More time playing</strong>
          </Typography>
        </div>
        <Typography
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            fontSize: isDesktop ? "0.7rem" : "0.55rem",
            color: "white",
            textShadow: "0 0 10px rgba(0,0,0,0.8)",
            opacity: 0.9
          }}
        >
          © K. Kerley Photography
        </Typography>
      </ParallaxBanner>
    );
  }
}

export default BackgroundParallax;
